<h2
  class="inline-flex items-center justify-center px-5 py-1 text-2xl font-medium text-gray-800 rounded-lg cursor-pointer me-2">
  {{dataType}}
</h2>

<div class="flex mt-8" *ngIf="routeNavigate!='utilisateurs/ajout'">
  <button type="button" (click)="navigate()"
    class="cursor-pointer items-center justify-center py-2.5 px-5 me-2 text-sm font-medium text-gray-800 bg-white rounded-lg border border-gray-200 hover:bg-gray-50 focus:z-10 focus:ring-4 focus:ring-gray-200 focus:outline-none inline-flex">
    Créer un(e) {{boutonDataType}}
  </button>
</div>

<form class="flex items-center max-w-lg mx-auto mt-8 mb-8">
  <label for="voice-search" class="sr-only">Search</label>
  <div class="relative w-full">
    <div class="absolute inset-y-0 flex items-center pointer-events-none start-0 ps-3">
      <svg class="w-4 h-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
        viewBox="0 0 21 21">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M11.15 5.6h.01m3.337 1.913h.01m-6.979 0h.01M5.541 11h.01M15 15h2.706a1.957 1.957 0 0 0 1.883-1.325A9 9 0 1 0 2.043 11.89 9.1 9.1 0 0 0 7.2 19.1a8.62 8.62 0 0 0 3.769.9A2.013 2.013 0 0 0 13 18v-.857A2.034 2.034 0 0 1 15 15Z" />
      </svg>
    </div>
    <input type="text" id="voice-search" (input)="onInputChange($event)"
      class="bg-white border border-gray-300 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5"
      placeholder="Search Patterns, occurs..." required />
  </div>
</form>

<div class="flex justify-center mt-8">
  <button disabled type="button" *ngIf="!data"
    class="items-center justify-center py-2.5 px-5 me-2 text-sm font-medium text-gray-800 bg-white rounded-lg border border-gray-200 hover:bg-gray-50 focus:z-10 focus:ring-4 focus:ring-gray-200 focus:outline-none inline-flex items-center">
    <svg aria-hidden="true" role="status" class="inline w-4 h-4 text-gray-300 me-3 animate-spin" viewBox="0 0 100 101"
      fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        fill="#E5E7EB" />
      <path
        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        fill="#3B82F6" />
    </svg>
    Loading...
  </button>
</div>

<table *ngIf="filteredData.length>0" class="w-full m-2 text-sm text-left text-gray-800">
  <thead class="text-xs text-gray-800 uppercase bg-gray-100">
    <tr>
      <th *ngFor="let col of columns.field" scope="col" class="px-6 py-3">
        {{col}}
      </th>
      <th scope="col" class="px-6 py-3" *ngIf="routeNavigate!=='utilisateurs/ajout'">
        Actions
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let line of filteredData; let i = index" class="bg-white border-b border-gray-200 hover:bg-gray-50">
      <th scope="row" class="px-6 py-4 font-medium text-gray-800 whitespace-nowrap">
        {{i+1}}
      </th>
      <td class="px-6 py-4 text-gray-800" *ngFor="let col of columns.columnsName.slice(1)">
        <span *ngIf="col === 'status'" [ngClass]="{
            'bg-green-100 text-green-800 px-3 p-1 py-1 rounded-full text-sm font-medium': getNestedValue(line, col) === true,
            'bg-red-100 text-red-800 px-3 py-1 p-1 rounded-full text-sm font-medium': getNestedValue(line, col) === false
          }">
          {{ getNestedValue(line, col) === true ? 'Conforme' : 'Non conforme' }}
        </span>

        <!-- Pour les autres colonnes, affichage normal -->
        <span *ngIf="col !== 'status'">
          {{ getNestedValue(line, col) }}
        </span>
      </td>
      <td class="flex flex-row items-center gap-2 px-6 py-4 text-gray-800">
        <!-- Edit button CertificatControls-->
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
          class="text-gray-600 cursor-pointer size-6 hover:text-gray-800"
          *ngIf="dataType === 'Gestion des Rapports d\'Inspection'"
          (click)="navigateToCerticatControlFormUpdate(line.id)">
          <path
            d="M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32l8.4-8.4Z" />
          <path
            d="M5.25 5.25a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3V13.5a.75.75 0 0 0-1.5 0v5.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V8.25a1.5 1.5 0 0 1 1.5-1.5h5.25a.75.75 0 0 0 0-1.5H5.25Z" />
        </svg>

        <!-- Edit button Badges-->
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
          class="text-gray-600 cursor-pointer size-6 hover:text-gray-800"
          *ngIf="dataType === 'Gestion des Cartes d\'Inspection'" (click)="updateBadge(line.id)">
          <path
            d="M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32l8.4-8.4Z" />
          <path
            d="M5.25 5.25a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3V13.5a.75.75 0 0 0-1.5 0v5.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V8.25a1.5 1.5 0 0 1 1.5-1.5h5.25a.75.75 0 0 0 0-1.5H5.25Z" />
        </svg>

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
          class="text-gray-600 cursor-pointer size-6 hover:text-gray-800"
          *ngIf="dataType==='Gestion des Rapports d\'Inspection'" (click)="generateReportAction(line.id)">
          <path
            d="M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5H5.625Z" />
          <path
            d="M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z" />
        </svg>

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
          class="text-gray-600 cursor-pointer size-6 hover:text-gray-800"
          *ngIf="dataType==='Gestion des Cartes d\'Inspection'" (click)="navigateToCardForPrint(line.id)">
          <path d="M4.5 3.75a3 3 0 0 0-3 3v.75h21v-.75a3 3 0 0 0-3-3h-15Z" />
          <path fill-rule="evenodd"
            d="M22.5 9.75h-21v7.5a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-7.5Zm-18 3.75a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z"
            clip-rule="evenodd" />
        </svg>

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
          class="text-gray-600 cursor-pointer size-6 hover:text-gray-800"
          *ngIf="dataType==='Gestion des Cartes d\'Inspection'" (click)="generateQrCode(line.numero)">
          <path fill-rule="evenodd"
            d="M3 4.875C3 3.839 3.84 3 4.875 3h4.5c1.036 0 1.875.84 1.875 1.875v4.5c0 1.036-.84 1.875-1.875 1.875h-4.5A1.875 1.875 0 0 1 3 9.375v-4.5ZM4.875 4.5a.375.375 0 0 0-.375.375v4.5c0 .207.168.375.375.375h4.5a.375.375 0 0 0 .375-.375v-4.5a.375.375 0 0 0-.375-.375h-4.5Zm7.875.375c0-1.036.84-1.875 1.875-1.875h4.5C20.16 3 21 3.84 21 4.875v4.5c0 1.036-.84 1.875-1.875 1.875h-4.5a1.875 1.875 0 0 1-1.875-1.875v-4.5Zm1.875-.375a.375.375 0 0 0-.375.375v4.5c0 .207.168.375.375.375h4.5a.375.375 0 0 0 .375-.375v-4.5a.375.375 0 0 0-.375-.375h-4.5ZM6 6.75A.75.75 0 0 1 6.75 6h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75A.75.75 0 0 1 6 7.5v-.75Zm9.75 0A.75.75 0 0 1 16.5 6h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75ZM3 14.625c0-1.036.84-1.875 1.875-1.875h4.5c1.036 0 1.875.84 1.875 1.875v4.5c0 1.035-.84 1.875-1.875 1.875h-4.5A1.875 1.875 0 0 1 3 19.125v-4.5Zm1.875-.375a.375.375 0 0 0-.375.375v4.5c0 .207.168.375.375.375h4.5a.375.375 0 0 0 .375-.375v-4.5a.375.375 0 0 0-.375-.375h-4.5Zm7.875-.75a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75Zm6 0a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75ZM6 16.5a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75Zm9.75 0a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75Zm-3 3a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75Zm6 0a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75Z"
            clip-rule="evenodd" />
        </svg>

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
          class="text-red-500 cursor-pointer size-6 hover:text-red-700"
          *ngIf="dataType==='Gestion des Rapports d\'Inspection'" (click)="openDeleteModal(line.id)">
          <path fill-rule="evenodd"
            d="M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z"
            clip-rule="evenodd" />
        </svg>

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
          class="text-red-500 cursor-pointer size-6 hover:text-red-700"
          *ngIf="dataType==='Gestion des Cartes d\'Inspection'" (click)="openDeleteModal(line.id)">
          <path fill-rule="evenodd"
            d="M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z"
            clip-rule="evenodd" />
        </svg>
      </td>
    </tr>
  </tbody>
</table>

<div aria-label="Page navigation example" class="flex justify-between mt-4" *ngIf="filteredData.length>0">
  <span class="text-sm font-normal text-gray-700">
    Affichage de <span class="font-semibold">{{ itemsPerPage }}</span> sur <span class="font-semibold">{{totalElements
      }}</span>
  </span>
  <div class="inline-flex space-x-2">
    <button (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1"
      class="flex items-center justify-center h-8 px-3 text-sm font-medium text-gray-800 bg-white border border-gray-300 rounded-lg hover:bg-gray-100">
      Précédent
    </button>
    <span *ngFor="let pageNumber of [].constructor(totalPages); let i = index" (click)="changePage(i + 1)" [ngClass]="{
        'bg-blue-50 text-blue-600 border-blue-300': currentPage === (i + 1),
        'bg-white text-gray-800 border-gray-300': currentPage !== (i + 1)
      }" class="flex items-center justify-center h-8 px-3 text-sm font-medium border rounded-lg cursor-pointer">
      {{ i + 1 }}
    </span>
    <button (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages"
      class="flex items-center justify-center h-8 px-3 text-sm font-medium text-gray-800 bg-white border border-gray-300 rounded-lg hover:bg-gray-100">
      Suivant
    </button>
  </div>
</div>


<app-toast type="warning" message="Element supprimé" *ngIf="showToastTest"></app-toast>

<!-- Modal de Confirmation -->
<div *ngIf="showDeleteModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="w-full max-w-md p-6 bg-white rounded-lg shadow">
    <div class="flex items-center justify-between mb-4">
      <h3 class="text-xl font-semibold text-gray-800">
        Confirmer la suppression
      </h3>
      <button (click)="closeDeleteModal()" class="text-gray-500 hover:text-gray-700">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <div class="mb-6">
      <p class="text-gray-600">
        Êtes-vous sûr de vouloir supprimer cet élément ? Cette action est
        irréversible.
      </p>
    </div>

    <div class="flex justify-end space-x-3">
      <button (click)="closeDeleteModal()" class="px-4 py-2 text-gray-800 bg-gray-200 rounded-lg hover:bg-gray-300">
        Annuler
      </button>
      <button (click)="confirmDelete()" class="px-4 py-2 text-white bg-red-600 rounded-lg hover:bg-red-700">
        Supprimer
      </button>
    </div>
  </div>
</div>
